<template>
  <div>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modal"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          Vídeo de Ajuda
        </div>
      </template>

      <div class="video-wrapper">
        <div v-if="videoLoading && url_video" class="video-loading-state">
          <div class="spinner-border-custom">
            <i class="fas fa-circle-notch fa-spin"></i>
          </div>
          <p class="loading-text">Carregando vídeo...</p>
        </div>

        <video
          v-if="url_video"
          v-show="!videoLoading"
          ref="videoPlayer"
          width="100%"
          controls
          controlsList="nodownload noremoteplayback"
          disablePictureInPicture
          crossorigin="anonymous"
          class="video-player"
          @loadstart="videoLoading = true"
          @canplay="onCanPlay"
        >
          <source :src="url_video" type="video/mp4" />
          Seu navegador não suporta a reprodução de vídeos.
        </video>

        <div v-if="!url_video" class="video-empty-state">
          <i class="fas fa-video-slash empty-icon"></i>
          <p class="empty-text">Nenhum vídeo disponível.</p>
        </div>
      </div>
    </b-modal>

    <v-btn @click="$bvModal.show('modal')" class="btn-help-video m-1" small>
      <i class="fas fa-play mr-2"></i> Ver Vídeo de Ajuda
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "HelpVideo",

  props: {
    url_video: String,
  },

  data() {
    return {
      loading: false,
      videoLoading: false,
    };
  },

  methods: {
    onCanPlay() {
      this.videoLoading = false;
      this.$refs.videoPlayer.play();
    },
  },
};
</script>

<style scoped>
.video-wrapper {
  background: #0f172a;
  border-radius: 12px;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.video-player {
  max-height: 70vh;
  border-radius: 8px;
  display: block;
}

.video-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #94a3b8;
}

.spinner-border-custom i {
  font-size: 36px;
  color: #0f65b0;
}

.loading-text {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}

.video-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #64748b;
}

.empty-icon {
  font-size: 36px;
  color: #475569;
}

.empty-text {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.btn-help-video {
  background: linear-gradient(135deg, #0f65b0 0%, #1d4ed8 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
  letter-spacing: 0 !important;
}

.btn-help-video:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

.btn-help-video:active {
  transform: scale(0.97) !important;
}

.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  padding: 20px 24px !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
  background: #ffffff;
}

.modern-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}

.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}
</style>